

import Vue from 'vue'
import ModalSimple from '@/components/ModalSimple.vue'
import {
  SOCIAL_BADGE,
  SOCIAL_BADGES,
  LINK_COPY
} from '@/constants'

export default Vue.extend({
  components: {
    ModalSimple
  },
  computed: {
    editorPage(): boolean {
      return this.$route.path == '/editor'
    },
    shareData(){
      return {
        URL: window.location.origin + this.$route.fullPath,
        MESSAGE: document.title
      }
    },
    socialBadges(): Array<SOCIAL_BADGE>{
      return SOCIAL_BADGES(this.shareData.URL, this.shareData.MESSAGE)
    }
  },
  methods: {
    closeModal() {
      this.$emit('onClose')
    },
    linkCopy() {
      return LINK_COPY(this.shareData.URL)
    }
  }
})
